module.exports = __webpack_public_path__ + "static/media/Slide67.bee64d23.JPG";